const zh = {
  warning: {
    start1: "您有认证信息即将过期，为了避免影响提现。",
    start2: "您有认证信息已过期，提现功能暂时无法使用。",
    middle: "点击此处",
    end: "前往更新信息。",
  },
  alertInfo: {
    submit: "更新",
    title: "您的认证信息",
    status1: "已过期",
    status2: "即将到期",
    label: "您登记的",
    label1: "法人",
    label2: "股东",
    label2_1: "董事",
    label3: "受益人",
    label4: "公司",
    label5: "证件信息",
    label6: "为避免影响提现，请尽快更新证件信息。",
    label7: "提现功能暂不可用，请尽快更新证件。在材料更新并审核通过后，我们将为您恢复提现服务，感谢您的配合。",
  },
}
export default zh